import React from 'react';
import "./banner.css";
const Banner = (props) => {
    return (
        <div className={`banner ${props.visible ?"animated fadeInUp": "opa-0"}`}>
            <div className="banner-content">
                <div className="banner-content-img">
                    <img src={props.content.img.src} alt={props.content.img.alt}/>
                </div>
                <div className="banner-content-info">
                    <div className="banner-content-info-title montserrat bold">{props.content.title}</div>
                    <div className="banner-content-info-description montserrat medium">{props.content.text}</div>
                </div>
            </div>
        </div>
    );
};

export default Banner;


// WEBPACK FOOTER //
// ./src/sections/Banner.js